export default __webpack_public_path__ + "static/media/admin.53a6c5a1.svg";